import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { Button } from '@/components/ui/button'

type SourceGroupReferenceBlockedDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description: string
  manageSourceGroupsHref?: string
  manageSourceGroupsLabel?: string
}

export function SourceGroupReferenceBlockedDialog({
  open,
  onOpenChange,
  title,
  description,
  manageSourceGroupsHref,
  manageSourceGroupsLabel,
}: SourceGroupReferenceBlockedDialogProps) {
  const { t } = useTranslation('common')

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          {manageSourceGroupsHref && manageSourceGroupsLabel ? (
            <Button variant="outline" asChild>
              <Link to={manageSourceGroupsHref}>{manageSourceGroupsLabel}</Link>
            </Button>
          ) : null}
          <AlertDialogAction>{t('actions.close')}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
